import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {error} from "../../../shared/utils/utils";

import {editarCliente} from "../../../api/cliente.service";
import { confirmDialog } from 'primereact/confirmdialog';

export const ModalEditarCliente = ({show, hide, fields}) => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const initParams = {
        cliente_id: '',
        nombre: "",
        nit: "",
        estado: "",
        direccion: "",
        facturacion: "",
        telefono: "",
        centro_costo: ""
    };
    // campos
    const [field, setField] = useState(initParams);

    useEffect(() => {
        setField({
            nombre: fields.nombre,
            nit: fields.nit,
            estado: fields.estado_id,
            direccion: fields.direccion,
            facturacion: fields.tipo_facturacion_id,
            telefono: fields.telefono,
            cliente_id: fields.cliente_id,
            centro_costo: fields.centro_costo
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);


    const onSubmit = async (e) => {
        try {
            e.preventDefault();
            if (field.nombre === ''
                || field.nit === ''
                || field.cliente_id === ''
                || field.estado === ''
                || field.facturacion === ''
                || field.centro_costo === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoad(true)
                    const response = await editarCliente(field);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide()

                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }

    }

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar cliente" visible={show} style={{width: '90vw'}}
                  onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información Cliente
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nombre"
                                    >
                                        Nombre *
                                    </label>
                                    <input
                                        id="nombre"
                                        type="text"
                                        className="form-input-small uppercase"
                                        value={field.nombre}
                                        onChange={(e) => setField({...field, nombre: e.target.value})}
                                    />
                                    {error(field.nombre, 'required')}
                                    {error(field.nombre, 'maxLength', 150)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nit"
                                    >
                                        Nit *
                                    </label>
                                    <input
                                        id="nit"
                                        type="number"
                                        className="form-input-small"
                                        value={field.nit}
                                        onChange={(e) => setField({...field, nit: e.target.value})}
                                    />
                                    {error(field.nit, 'required')}
                                    {error(field.nit, 'maxLength', 11)}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="centro_costo"
                                    >
                                        Centro de costos *
                                    </label>
                                    <input
                                        value={field.centro_costo}
                                        onChange={(e) => setField({...field, centro_costo: e.target.value})}
                                        id="centro_costo"
                                        type="text"
                                        className="form-input-small"
                                    />

                                    {error(field.centro_costo, 'required')}
                                    {error(field.centro_costo, 'maxLength', 5)}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="telefono"
                                    >
                                        telefono
                                    </label>
                                    <input
                                        value={field.telefono}
                                        onChange={(e) => setField({...field, telefono: e.target.value})}
                                        id="telefono"
                                        type="text"
                                        className="form-input-small"
                                    />

                                    {error(field.telefono, 'maxLength', 30)}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="facturacion"
                                    >
                                        Tipo de facturación *
                                    </label>
                                    <select
                                        className="form-input-small"
                                        value={field.facturacion}
                                        onChange={(e) => setField({...field, facturacion: e.target.value})}
                                        id="facturacion">
                                        <option value="">seleccione</option>
                                        <option value="E">Evento</option>
                                        <option value="H">Hora</option>
                                    </select>
                                    {error(field.facturacion, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        value={field.estado}
                                        onChange={(e) => setField({...field, estado: e.target.value})}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {error(field.estado, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="direccion"
                                    >
                                        Direccion
                                    </label>
                                    <input
                                        id="direccion"
                                        type="text"
                                        className="form-input-small"
                                        value={field.direccion}
                                        onChange={(e) => setField({...field, direccion: e.target.value})}
                                    />

                                    {error(field.direccion, 'maxLength', 250)}

                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </>
    );
};

ModalEditarCliente.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    fields: PropTypes.object
};


ModalEditarCliente.defaultProps = {
    show: false,
};
